// extracted by mini-css-extract-plugin
export default {"MemberTableItemLabel":"membersTableItemLabel_MemberTableItemLabel__Lkaqy"};